var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper",class:{'app-side-shrink':!_vm.sidebar.opened}},[_c('div',{staticClass:"app-layout-admin"},[_c('WtHeader'),_c('WtSide'),_c('WtBreadcrumb'),_c('div',{staticClass:"app-body"},[_c('section',{staticClass:"app-main"},[_c('router-view',{key:_vm.$route.path})],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }